import sendNotification from '../notifications/send';
import combineActions from '../../utils/combineActions';
import deleteGoal from './deleteGoal';
import getGoals from './getGoals';
import getLimit from './getLimit';

export default combineActions({
    sendNotification,
    getGoals,
    deleteGoal,
    getLimit,
});
